import styled, { css } from "styled-components";
import { media, theme } from "../../theme";
import { TOP_MENU_HEIGHT } from "../../layout/SideBarLayout/SidebarLayout.styles";

export const ContentGridDynamicElement = styled.div`
    grid-area: contentGridDynamic;
`;

export const ContentGridMainElement = styled.main`
    grid-area: contentGridMain;
`;

export const ContentGridWithFooterWrapper = styled.div<{ $skipSideBarDesktop: boolean; $isPrivateView: boolean; $disableInteraction: boolean }>`
    width: 100%;
    display: grid;
    min-height: 100vh;
    pointer-events: ${({ $disableInteraction }) => ($disableInteraction ? "none" : undefined)};
    background: ${({ theme }) => theme.customization.backgroundColor};
    grid-template-rows: auto 1fr auto; /* header, content, footer by default */
    grid-template-areas:
        "contentGridDynamic"
        "contentGridMain"
        "contentGridFooter";

    ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
        ${({ $skipSideBarDesktop }) =>
            !$skipSideBarDesktop &&
            css`
                grid-template-columns: auto 1fr auto;
                grid-template-rows: 1fr auto;
                grid-template-areas:
                    "contentGridDynamic contentGridMain"
                    "contentGridDynamic contentGridFooter";
            `}
    }

    ${ContentGridDynamicElement} {
        ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
            align-self: start;
            position: ${({ $skipSideBarDesktop }) => (!$skipSideBarDesktop ? "sticky" : undefined)};
            top: ${({ $skipSideBarDesktop, $isPrivateView }) => (!$skipSideBarDesktop ? ($isPrivateView ? `${TOP_MENU_HEIGHT}px` : "0") : undefined)};
            width: ${({ $skipSideBarDesktop }) => (!$skipSideBarDesktop ? "440px" : undefined)};
            overflow-y: ${({ $skipSideBarDesktop }) => (!$skipSideBarDesktop ? "auto" : undefined)};
            height: ${({ $skipSideBarDesktop, $isPrivateView }) =>
                !$skipSideBarDesktop ? `calc(100vh - ${$isPrivateView ? TOP_MENU_HEIGHT - 5 : 0}px)` : undefined};
            overscroll-behavior: ${({ $skipSideBarDesktop }) => (!$skipSideBarDesktop ? "contain" : undefined)};
        }
    }
`;

export const ContentGridFooterElement = styled.div`
    grid-area: contentGridFooter;
`;

export const ContentGridFooterPadding = styled.div`
    padding: 0 18px;

    ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
        padding: 0 48px;
    }
`;
